import React from "react";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Avatar,
  Divider,
  Tooltip,
} from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DeleteIcon from "@mui/icons-material/Delete";

const ListSchoolFee = ({ feeListData, setFeeListData, requireField }) => {
  const newFeeData = {
    discountPercentage: "",
    discountPrice: "",
    duration: "",
    price: "",
    key: Date.now() + Math.random(),
  };
  const handleAddFee = () => setFeeListData([...feeListData, newFeeData]);

  const handleRemoveFee = (key) => {
    const newFeeListData = feeListData.filter((e) => e.key !== key);
    setFeeListData(newFeeListData);
  };

  const handleChangeFee = (key, value, fiedName) => {
    const newFeeListData = feeListData?.map((e) => {
      if (e.key === key && fiedName === "PERCENTAGE")
        e.discountPercentage = value;
      if (e.key === key && fiedName === "D-PRICE") e.discountPrice = value;
      if (e.key === key && fiedName === "DURATION") e.duration = value;
      if (e.key === key && fiedName === "PRICE") e.price = value;
      return e;
    });
    setFeeListData(newFeeListData);
  };
  return (
    <Stack direction="column">
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Stack width="22%">
          <Typography className="field-title" fontSize="12px !important">Durtion</Typography>
        </Stack>
        <Stack width="20%">
          <Typography className="field-title" fontSize="12px !important">Price</Typography>
        </Stack>
        <Stack width="25%">
          <Typography className="field-title" fontSize="12px !important">Discount Percentage</Typography>
        </Stack>
        <Stack width="18%">
          <Typography className="field-title" fontSize="12px !important">Discount Price</Typography>
        </Stack>
        <Stack width="5%" direction="row-reverse">
          <Box>
            <IconButton sx={{ padding: "7px" }} onClick={handleAddFee}>
              <ControlPointIcon sx={{ color: "green" }} />
            </IconButton>
          </Box>
        </Stack>
      </Stack>

      <Stack direction="column" spacing={1}>
        <Divider />
        {feeListData.map((e, index) => (
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            key={e.index}
          >
            <Stack width="22%">
              <TextField
                fullWidth
                size="small"
                placeholder="0"
                value={e.duration}
                className="text-field"
                error={requireField && !e.duration}
                onChange={(event) => {
                  handleChangeFee(e.key, event.target.value, "DURATION");
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        "& .css-uem75i-MuiTypography-root": {
                          fontSize: "13px !important",
                        },
                      }}
                    >
                      /Month
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
            <Stack width="20%">
              <TextField
                fullWidth
                size="small"
                type="number"
                value={e.price}
                placeholder="0"
                className="text-field"
                error={requireField && !e.price}
                onChange={(event) => {
                  handleChangeFee(e.key, event.target.value, "PRICE");
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Stack>
            <Stack width="25%">
              <TextField
                fullWidth
                size="small"
                type="number"
                placeholder="0"
                className="text-field"
                value={e.discountPercentage}
                // error={requireField && !e.discountPercentage}
                onChange={(event) => {
                  handleChangeFee(e.key, event.target.value, "PERCENTAGE");
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Stack>
            <Stack width="18%">
              <TextField
                fullWidth
                size="small"
                type="number"
                placeholder="0"
                className="text-field"
                value={e.discountPrice}
                // error={requireField && !e.discountPrice}
                onChange={(event) => {
                  handleChangeFee(e.key, event.target.value, "D-PRICE");
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">%</InputAdornment>
                  ),
                }}
              />
            </Stack>
            <Stack width="5%" direction="row-reverse">
              <Box>
                <IconButton
                  sx={{ padding: "5px" }}
                  onClick={() => handleRemoveFee(e.key)}
                >
                  <DeleteIcon sx={{ color: "red" }} />
                </IconButton>
              </Box>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default ListSchoolFee;
